import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('../views/History.vue')
  },
  {
    path: '/preface',
    name: 'Preface',
    component: () => import('../views/Preface.vue')
  },
  {
    path: '/warriors',
    name: 'Warriors',
    component: () => import('../views/Warriors.vue')
  },
  {
    path: '/ancient',
    name: 'Ancient',
    component: () => import('../views/Ancient.vue')
  },
  {
    path: '/culture',
    name: 'Culture',
    component: () => import('../views/Culture.vue')
  },
  {
    path: '/visit',
    name: 'Visit',
    component: () => import('../views/Visit.vue')
  },
  {
    path: '/creation',
    name: 'Creation',
    component: () => import('../views/Creation.vue')
  },
  {
    path: '/game',
    name: 'Game',
    component: () => import('../views/Game.vue')
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
